export default __webpack_public_path__ + "static/media/H0001.d378dff4.png";